import * as actionTypes from "../../../actions/actionTypes";
const medicalRecord = (
  state = {
    dataChanged: false,
    medical_records: [],
    removed_medical_records: [],
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SET_MEDICAL_RECORD:
      return {
        ...state,
        dataChanged: true,
        ...action.payload,
      };

    case actionTypes.ADD_MEDICAL_RECORD: {
      const medical_records = [...state.medical_records];

      medical_records.push({
        medical_record_name: state.current_medical_record_name,
        document: state.current_document,
        examination_date: state.current_examination_date,
        record_type: state.current_record_type,
        new_record: true,
      });
      return {
        ...state,
        dataChanged: true,
        medical_records: medical_records,
        current_medical_record_name: "",
        current_document: "",
        current_examination_date: "",
        current_record_type: "",
        removed_medical_records: [],
      };
    }

    case actionTypes.REMOVE_MEDICAL_RECORD: {
      const medical_records = [...state.medical_records];
      const removed_medical_records = [...state.removed_medical_records];
      medical_records[action.payload.index] &&
        removed_medical_records.push(medical_records[action.payload.index]);

      medical_records.splice(action.payload.index, 1);
      return {
        ...state,
        dataChanged: true,
        medical_records: medical_records,
        removed_medical_records: removed_medical_records,
      };
    }

    default:
      return state;
  }
};

export default medicalRecord;
